import classnames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { NavItem, NavLink } from "reactstrap";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  tabText: string;
  isActive: boolean;
  onClick: () => void;
}

const ToolbarTab: React.FC<IParams> = ({ tabText, isActive, onClick }) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;

  return (
    <>
      <NavItem>
        <NavLink
          href="#"
          className={classnames(
            { active: isActive },
            "toolbarTab",
            isActive
              ? `${theme!.toolbarSelectedTabBackground} ${
                  theme!.toolbarSelectedTabText
                }`
              : ""
          )}
          onClick={onClick}
        >
          {tabText}
        </NavLink>
      </NavItem>
    </>
  );
};

export default observer(ToolbarTab);
